import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["checked", "disabled", "className", "size", "label", "children", "indeterminate", "onChange", "onClick"];
import cx from 'classnames';
import omit from 'lodash.omit';
import React, { forwardRef } from 'react';
import { IconCheckmarkMediumOutline, IconCheckmarkSmallOutline, IconMinusSmallOutline } from '../../assets/icons/components';
import Box, { omitBoxProps, pickBoxProps } from '../box';
import { TextBodyCompact, TextDisplay, TextSmall } from '../typography';
import theme from './theme.css';
var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _cx;
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    label = _ref.label,
    children = _ref.children,
    _ref$indeterminate = _ref.indeterminate,
    indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    others = _objectWithoutProperties(_ref, _excluded);
  var TextElement = size === 'small' ? TextSmall : size === 'medium' ? TextBodyCompact : TextDisplay;
  var IconCheckmark = size === 'large' ? IconCheckmarkMediumOutline : IconCheckmarkSmallOutline;
  var restProps = omit(others, ['onChange']);
  var boxProps = pickBoxProps(restProps);
  var inputProps = omitBoxProps(restProps);
  var classNames = cx(theme['checkbox'], theme["is-".concat(size)], (_cx = {}, _defineProperty(_cx, theme['is-checked'], checked || indeterminate), _defineProperty(_cx, theme['is-disabled'], disabled), _cx), className);
  return /*#__PURE__*/React.createElement(Box, _extends({
    element: "label",
    "data-teamleader-ui": "checkbox",
    className: classNames,
    onClick: onClick
  }, boxProps), /*#__PURE__*/React.createElement("input", _extends({
    className: theme['input'],
    type: "checkbox",
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    ref: ref,
    readOnly: true
  }, inputProps)), /*#__PURE__*/React.createElement("span", {
    className: theme['shape']
  }, checked ? /*#__PURE__*/React.createElement(IconCheckmark, {
    className: theme['icon']
  }) : /*#__PURE__*/React.createElement(IconMinusSmallOutline, {
    className: theme['icon']
  })), (label || children) && /*#__PURE__*/React.createElement("span", {
    className: theme['label']
  }, label && /*#__PURE__*/React.createElement(TextElement, {
    element: "span"
  }, label), children));
});
Checkbox.displayName = 'Checkbox';
export default Checkbox;